<template>
  <div >
    <div class="title_tabs">
      <!-- <div :class="index=='1'?'active_tab':''" @click="tabClick('1')">订单列表</div> -->
      <div :class="index=='2'?'active_tab':''" @click="tabClick('2')">异常订单</div>
      <div :class="index=='3'?'active_tab':''" @click="tabClick('3')">财务列表</div>
      <div :class="index=='4'?'active_tab':''" @click="tabClick('4')">时间设置</div>
    </div>
    <div class="main">
      <!-- <div v-if="index=='1'">
          <div class="ones_top">
            <div class="title_inputs">
              <el-input placeholder="订单号"></el-input>
              <span>日期：</span>
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <el-select clearable placeholder="请选择分销商">
                <el-option
                  v-for="item in cityProvince"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                ></el-option>
              </el-select>
              <el-select clearable placeholder="全部状态">
                <el-option
                  v-for="item in cityProvince"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                ></el-option>
              </el-select>
              <div class="chaxun">
                查询
              </div>
            </div>
            <div class="export_btns">
              导出报表
            </div>
          </div>
          <div class="center">
            <el-table
              :data="tableData"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              v-loading="loading"
              style="width: 100%">
                <el-table-column prop="channelName" label="核销时间"></el-table-column>
                <el-table-column prop="channelName" label="分销商"></el-table-column>
                <el-table-column prop="channelName" label="订单号"></el-table-column>
                <el-table-column prop="channelName" label="消费码"></el-table-column>
                <el-table-column prop="channelName" label="第三方订单号"></el-table-column>
                <el-table-column prop="channelName" label="订单内容"></el-table-column>
                <el-table-column prop="channelName" label="状态"></el-table-column>
                <el-table-column prop="channelName" label="操作">
                  <template slot-scope="scope">
                    <span class="blue_css" @click="openClick">查看详情</span>
                  </template>
                </el-table-column>

            </el-table>
          </div>
          <div class="pagination">
            <span class="demonstration">共{{data.total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="data.page_size" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
          </div>
      </div> -->
      <div v-if="index=='2'">
        <div class="ones_top">
            <div class="title_inputs">
              <el-input placeholder="消费码" v-model="data.ordercode"></el-input>
              <span>日期：</span>
              <el-date-picker
                v-model="value1"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-select  v-model="data.DistributorID" filterable clearable placeholder="请选择分销商">
                <el-option
                  v-for="item in options1"
                  :key="item.DistrbutorID"
                    :label="item.Name"
                    :value="item.DistrbutorID"
                ></el-option>
              </el-select>
              <el-select clearable v-model="data.state" placeholder="全部状态">
                <el-option
                  v-for="item in option"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="chaxun" @click="yichangBtns">
                查询
              </div>
            </div>
            <div class="export_btns" @click="exporShensu">
              导出报表
            </div>
        </div>
        <div class="center">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            v-loading="loading"
            style="width: 100%">
              <el-table-column prop="createtime" label="申诉时间"></el-table-column>
              <el-table-column prop="distributor_name" label="分销商"></el-table-column>
              <el-table-column prop="ordernumber" label="订单号"></el-table-column>
              <el-table-column prop="ordercode" label="消费码"></el-table-column>
              <el-table-column prop="OnlyCode" label="第三方订单号"></el-table-column>
              <el-table-column prop="canRefund" label="可退金额"></el-table-column>
              <el-table-column prop="channelName" label="状态">
                <template slot-scope="scope">
                    <div style="display:flex;color:#FF4D4F;" v-if="scope.row.state=='1'">
                      {{scope.row.state=='1'?'待处理':''}}
                    </div>
                    <div style="display:flex;" v-if="scope.row.state=='2'">
                      {{scope.row.state=='2'?'已处理':''}}
                    </div>
                </template>
              </el-table-column>
              <el-table-column prop="channelName" label="操作"    fixed="right">
                <template slot-scope="scope">
                    <div style="display:flex;">
                      <span class="blue_css" @click="abnClick(scope.row)">查看详情</span>
                      <span class="red_css" @click="tongbu(scope.row)">{{scope.row.state=='1'?'强制退款':''}}</span>
                    </div>
                </template>
              </el-table-column>

          </el-table>
          <div class="pagination">
            <span class="demonstration">共{{data.total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="data.page_size" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
          </div>
        </div>
      </div>
      <div v-if="index=='3'">
        
        <div class="ones_top">
          <div style="margin-bottom:2rem;">
            <span style="color:red;font-size:1.6rem;">注：小程序线上交押金订单列表</span>
          </div>
            <div class="title_inputs">
              <el-input placeholder="消费码" v-model="data1.ordercode"></el-input>
              <span>日期：</span>
              <el-date-picker
                v-model="value2"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-select  v-model="data1.DistributorID" filterable clearable placeholder="请选择分销商">
                <el-option
                  v-for="item in options1"
                  :key="item.DistrbutorID"
                    :label="item.Name"
                    :value="item.DistrbutorID"
                ></el-option>
              </el-select>
              <el-select  v-model="data1.type" placeholder="报表类型">
                <el-option
                  v-for="item in optiontype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select clearable v-model="data1.state" placeholder="全部状态">
                <el-option
                  v-for="item in optionone"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="chaxun" @click="orderbtns">
                查询
              </div>
            </div>
            <div class="export_btns" @click="orderExoBtns">
              导出报表
            </div>
        </div>
        <!-- <div class="content_txt">
          <span>充值总金额：</span>
            <span class="deb">2365.56</span>
             <span>元，消费总金额：</span> 
             <span class="deb">2365.56</span>  
             <span>元，退款总金额：</span>
              <span class="deb">2365.56</span> <span>元</span> 
        </div> -->
        <div class="center">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            v-loading="loading"
            style="width: 100%">
              <el-table-column prop="ordernumber" label="订单号"></el-table-column>
              <el-table-column prop="ordercode" label="消费码"></el-table-column>
              <el-table-column prop="UseTime" label="核销时间"></el-table-column>
              <el-table-column prop="amount" label="充值金额"></el-table-column>
              <el-table-column prop="UseFee" label="消费金额"></el-table-column>
              <el-table-column prop="refund_deposit" label="退款金额"></el-table-column>
              <el-table-column  label="状态">
                <template slot-scope="scope">
                      <span >{{scope.row.status=='1'?'使用中':'已结账'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="channelName" label="操作"    fixed="right">
                <template slot-scope="scope">
                    <div style="display:flex;">
                      <span class="blue_css"  @click="openClick(scope.row)">查看详情</span>
                    </div>
                </template>
              </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="demonstration">共{{data1.total}}条记录，</span>
            <span class="demonstration">当前显示第{{data1.page}}页</span>
            <el-pagination background layout="prev, pager, next" :total="data1.total" :page-size="data1.page_size" :current-page="data1.page"  @current-change="currenchange1" ></el-pagination>
          </div>
        </div>
      </div>
      <div v-if="index=='4'">
        <div class="title">
        验证时间设置
        </div>
        <div class="content">
          <div>
            <span>开始时间：</span>
            <el-time-picker
              v-model="recharge_start_time"
              :editable="false"
              :clearable="false"
              value-format="HH:mm:ss"
              placeholder="开始时间">
            </el-time-picker>
          </div>
          <div>
            <span>充值结束时间：</span>
              <el-time-picker
              v-model="recharge_end_time"
              :editable="false" :clearable="false"
              value-format="HH:mm:ss"
              placeholder="充值结束时间">
            </el-time-picker>
          </div>
          <div>
            <span>结账结束时间：</span>
              <el-time-picker
              v-model="checkout_end_time"
              :editable="false" :clearable="false"
              value-format="HH:mm:ss"
              placeholder="结账结束时间">
            </el-time-picker>
          </div>
          <div class="btns" @click="btnsClick">
            确定保存
          </div>
        </div>
        <div class="content">
          
        </div>
      </div>
    </div>
    <xcxorder v-if="orderflow" ref="addProDialog" @addProClose="xcxOrderClose"></xcxorder>
    <abnormal v-if="abnflow" ref="abnDialog"></abnormal>
  </div>
</template>

<script>
import { xcxAppealState , xcxAppealOrderListExport , xcxOrderListExport , rechargeTimeLimit , ScenicMessage , xcxAppealOrderList ,getScenicListDistrbutor , xcxOrderList } from '@/request/scenic.js'
import xcxorder from './workbench/xcxorder.vue'
import abnormal from './workbench/abnormal.vue'
import { MessageBox } from 'element-ui'
export default {
  components: {
    xcxorder,
    abnormal
  },
  data(){
    return{
      optiontype:[
          {
            label:'订单列表',
            value:1
          },
          {
            label:'财务报表',
            value:2
          }
      ],
      optionone:[
        {
            label:'使用中',
            value:1
          },
          {
            label:'已结账',
            value:2
          }
      ],
      recharge_start_time:'',
      recharge_end_time:'',
      checkout_end_time:'',
      index:'2',
      tableData:[{}],
      orderflow:false,
      loading:true,
      data:{
        total:0,
        page:1,
        page_size:10,
        token:window.sessionStorage.getItem('Token'),
        start_time:'',
        end_time:'',
        ordercode:'',
        state:'',
        DistributorID:''
      },
      abnflow:false,
      value1:'',
      option:[
        {
          value:'1',
          label:'待处理'
        },
        {
          value:'2',
          label:'已处理'
        }
      ],
      options1: [
        {
          DistrbutorID:"0",
          Name:'景区直销'
        }
      ],
      data1:{
        total:0,
        page:1,
        page_size:10,
        token:window.sessionStorage.getItem('Token'),
        start_time:'',
        end_time:'',
        ordercode:'',
        type:2,
        DistributorID:'',
        state:''
      },
      value2:''
    }
  },
  created(){
    let dataes = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
      getScenicListDistrbutor(dataes).then(res=>{
        if(res.data.rcode==200){
            this.options1 = [...this.options1,...res.data.result.data]
        }
      })
    this.value1 = [this.getTodayTime(),this.getTodayTime()]
    if(this.value1){
      this.data.start_time = this.value1[0] 
      this.data.end_time = this.value1[1] 
    }else{
      this.data.start_time = ''
      this.data.end_time = ''
    }
    let datas = {
        token:window.sessionStorage.getItem('Token'),
      }
    ScenicMessage(datas).then(res=>{
      if(res.data.status=='ok'){
          if(res.data.result.recharge_start_time!=''){
            this.recharge_start_time = res.data.result.recharge_start_time
            this.recharge_end_time = res.data.result.recharge_end_time
            this.checkout_end_time = res.data.result.checkout_end_time
          }
      }
    })
    this.loading = false    
    this.getxcxList()
  },
  methods:{
    orderExoBtns(){
      let data = {
          token:window.sessionStorage.getItem('Token'),
          start_time:"",
          end_time:'',
          type:this.data1.type,
          ordercode:this.data1.ordercode,
          state:this.data1.state,
          DistributorID:this.data1.DistributorID
        }
        if(this.value2){
          data.start_time = this.value2[0] 
          data.end_time = this.value2[1] 
        }else{
          this.$message.error('请选择时间')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        xcxOrderListExport(data).then(res=>{
          if(res.data.status=='ok'){
              loading.close();
              window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
    },
    exporShensu(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          start_time:"",
          end_time:'',
          ordercode:this.data.ordercode,
          state:this.data.state,
          DistributorID:this.data.DistributorID
        }
        if(this.value1){
          data.start_time = this.value1[0] 
          data.end_time = this.value1[1] 
        }else{
          this.$message.error('请选择时间')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        xcxAppealOrderListExport(data).then(res=>{
          if(res.data.status=='ok'){
              loading.close();
              window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
    },
    tongbu(row){
      MessageBox(`此操作将强制退款, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          token:window.sessionStorage.getItem('Token'),
          appeal_id:row.id
        }
        xcxAppealState(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('强制退款成功')
            this.getxcxList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
     
    },
    orderbtns(){
      this.data.page = 1
      if(this.value2){
        this.data1.start_time = this.value2[0] 
        this.data1.end_time = this.value2[1] 
      }else{
        this.$message.error('请选择时间')
        return false
      }
      this.getOrderList()
    },
    getOrderList(){
      xcxOrderList(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data1.total = res.data.result.total
        }
      })
    },
    currenchange1(e){
      this.data1.page = e
      this.getOrderList()
    },
    currenchange(e){
        this.data.page = e
        this.getxcxList()
    },
    yichangBtns(){
      this.data.page = 1
      if(this.value1){
        this.data.start_time = this.value1[0] 
        this.data.end_time = this.value1[1] 
      }else{
       this.$message.error('请选择时间')
      }
      this.getxcxList()
    },
    getTodayTime() {
      var day = new Date();
      let seconds = day.getSeconds();
      if (seconds < 10) { // 如果月份值小于10，则在前面加上0
        seconds = "0" + seconds;
      } else {
        seconds = seconds;
      }
      let minutes = day.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      } else {
        minutes = minutes;
      }
      let month = day.getMonth()
      if (month < 10) {
      month = "0" + month;
      }
      let time = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate() 
      return time
    },
    getxcxList(){
      xcxAppealOrderList(this.data).then(res=>{
        if(res.data.status=='ok'){
          // console.log(res.data.result.data)
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }
      })
    },
    abnClick(row){
      this.abnflow = true;
      this.$nextTick(() => {
        this.$refs.abnDialog.addProFn(row);
      });
    },
    openClick(row){
        this.orderflow = true;
        this.$nextTick(() => {
          this.$refs.addProDialog.addProFn(row);
        });
    },
    xcxOrderClose(){
        this.orderflow = false
    },
      // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    tabClick(e){
      if(e==this.index){
        return false
      }
      this.tableData = []
      if(e==2){
        this.value1 = [this.getTodayTime(),this.getTodayTime()]
        if(this.value1){
          this.data.start_time = this.value1[0] 
          this.data.end_time = this.value1[1] 
        }else{
          this.data.start_time = ''
          this.data.end_time = ''
        }
        this.data.page = 1
        this.getxcxList()
      }
      if(e==3){
        this.value2 = [this.getTodayTime(),this.getTodayTime()]
        if(this.value2){
          this.data1.start_time = this.value2[0]
          this.data1.end_time = this.value2[1]
        }else{
          this.data1.start_time = ''
          this.data1.end_time = ''
        }
        this.data1.page = 1
        this.getOrderList()
      }
      this.index = e
    },
    btnsClick(){
      if(this.recharge_start_time==''){
        this.$message.error('请选择充值开始时间')
        return false
      }
      if(this.recharge_end_time==''){
        this.$message.error('请选择充值结束时间')
        return false
      }
      if(this.checkout_end_time==''){
        this.$message.error('请选择结账结束时间')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        recharge_start_time:this.recharge_start_time,
        recharge_end_time:this.recharge_end_time,
        checkout_end_time:this.checkout_end_time
      }
      rechargeTimeLimit(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('设置成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.title_tabs{
  display: flex;
  align-items: center;
  >div{
    cursor: pointer;
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #D9D9D9;
    color: #fff;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2rem;
  }
  .active_tab{
    background: #246DEB;
  }
}
.main{
  background: #fff;
  min-height: 80vh;
  margin-top: 2rem;
  .title{
    padding: 1.7rem 2rem;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E5EA;
    font-size: 1.8rem;
    color: #000000;
  }
  .content{
    padding: 2rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    >div{
      display: flex;
      align-items: center;
      >span{
        margin-right: 1rem;
        display: block;
        width: 10rem;
        text-align: right;
        font-size: 1.4rem;
      }
      &:nth-child(n+2){
        margin-left: 2rem;
      }
      ::v-deep .el-date-editor{
        width: 30rem;
      }
    }
    .btns{
      justify-content: center;
      width: 10rem;
      height: 4rem;
      border: 1px solid #246DEB;
      border-radius: 0.4rem;
      font-size: 1.4rem;
      color: #246DEB;
      cursor: pointer;
      margin-left: 2rem;
    }
  }
}
.ones_top{
  padding: 2rem 2rem 0 2rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .title_inputs{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ::v-deep .el-input{
      width: 22rem;
      margin-bottom: 2rem;
    }
    >span{
      margin-left: 2rem;
      font-size: 1.4rem;
      color: #666666;  margin-bottom: 2rem;
    }
    ::v-deep .el-date-editor{
      width: 28rem;
      margin: 0 0 2rem 0;
    }
    ::v-deep .el-select{
      margin-left: 2rem;
      width: 22rem;
    }
    .chaxun{
      width: 10rem;
      height: 4rem;  margin-bottom: 2rem;
      border-radius: 0.4rem;
      background: #246DEB;
      font-size: 1.4rem;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 2rem;
      cursor: pointer;
    }
  }
  .export_btns{
    width: 12rem;
    height: 4rem;  margin-bottom: 2rem;
    cursor: pointer;
    border: 1px solid #246DEB;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    color: #246DEB;
  }
}
.center{
  padding: 2rem;
  box-sizing: border-box;
}
.content_txt{
  padding: 0 2rem;
  box-sizing: border-box;
  display: flex;
  span{
    color:#666666;
    font-size: 1.4rem;
  }
  .deb{
    color: #246DEB;
  }
}
.blue_css{
  color: #246DEB;
  font-size: 1.4rem;
  cursor: pointer;
}
.red_css{
  color: #FF4D4F;
  font-size: 1.4rem;
  cursor: pointer;
  display: flex;
  margin-left: 2rem;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
::v-deep .has-gutter th , ::v-deep .el-table__row td{
  text-align: left !important;
}
</style>